import React, { useEffect, useState } from 'react';
import { Settings as SettingsIcon, Lock, Save, Globe } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function Settings() {
  const [settings, setSettings] = useState({ company_name: '', default_country_code: '54' });
  const [passwords, setPasswords] = useState({ current_password: '', new_password: '', confirm: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/settings').then(res => setSettings(prev => ({ ...prev, company_name: res.data.company_name || '', default_country_code: res.data.default_country_code || '54' })));
  }, []);

  const saveSettings = async () => {
    setSaving(true);
    try {
      await api.put('/settings', settings);
      toast.success('Configuración guardada');
    } catch (err) { toast.error('Error al guardar'); }
    finally { setSaving(false); }
  };

  const changePassword = async () => {
    if (passwords.new_password !== passwords.confirm) return toast.error('Las contraseñas no coinciden');
    if (passwords.new_password.length < 8) return toast.error('Mínimo 8 caracteres');
    try {
      await api.put('/auth/change-password', {
        current_password: passwords.current_password,
        new_password: passwords.new_password
      });
      toast.success('Contraseña actualizada');
      setPasswords({ current_password: '', new_password: '', confirm: '' });
    } catch (err) { toast.error(err.response?.data?.error || 'Error al cambiar contraseña'); }
  };

  return (
    <div style={{ maxWidth: 640 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <SettingsIcon size={24} color="var(--accent)" />
        <h1 style={{ fontSize: 26, fontWeight: 800 }}>Configuración</h1>
      </div>

      {/* General */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <Globe size={18} color="var(--accent)" />
          <h3 style={{ fontSize: 16, fontWeight: 700 }}>General</h3>
        </div>
        <div className="form-group">
          <label>Nombre de la empresa</label>
          <input value={settings.company_name || ''} onChange={e => setSettings({...settings, company_name: e.target.value})} />
        </div>
        <div className="form-group">
          <label>Código de país por defecto (para WhatsApp)</label>
          <input value={settings.default_country_code || ''} onChange={e => setSettings({...settings, default_country_code: e.target.value})}
            placeholder="54" style={{ width: 100 }} />
          <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>Argentina = 54, México = 52, Colombia = 57, etc.</p>
        </div>
      </div>

      <button className="btn btn-primary" onClick={saveSettings} disabled={saving} style={{ marginBottom: 28 }}>
        <Save size={16} /> {saving ? 'Guardando...' : 'Guardar configuración'}
      </button>

      {/* Password */}
      <div className="card">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <Lock size={18} color="var(--accent)" />
          <h3 style={{ fontSize: 16, fontWeight: 700 }}>Cambiar contraseña</h3>
        </div>
        <div className="form-group">
          <label>Contraseña actual</label>
          <input type="password" value={passwords.current_password}
            onChange={e => setPasswords({...passwords, current_password: e.target.value})} />
        </div>
        <div className="form-group">
          <label>Nueva contraseña</label>
          <input type="password" value={passwords.new_password}
            onChange={e => setPasswords({...passwords, new_password: e.target.value})} />
        </div>
        <div className="form-group">
          <label>Confirmar nueva contraseña</label>
          <input type="password" value={passwords.confirm}
            onChange={e => setPasswords({...passwords, confirm: e.target.value})} />
        </div>
        <button className="btn btn-secondary" onClick={changePassword}>
          <Lock size={14} /> Cambiar contraseña
        </button>
      </div>
    </div>
  );
}
